<script lang="ts" setup>
import { onUnmounted, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { debounce } from "lodash";
import { useAccount } from "@/stores/account.ts";
import { update } from "@/repositories/balance.ts";

const account = useAccount();

const { initialBalance } = storeToRefs(account);

const balance = ref(0);

const onChange = debounce(async () => {
  const value = Math.round(balance.value * 100);

  // Hydrating the field from the store is not an edit: without this the mount-time watcher wrote
  // the balance it had just loaded straight back to the API.
  if (value === initialBalance.value) {
    return;
  }

  if (await update(value)) {
    account.setBalance(value);
  }
}, 1500);

watch(balance, () => onChange());

watch(
  initialBalance,
  (value) => {
    balance.value = value / 100;
  },
  { immediate: true },
);

// A pending write must not fire against a torn-down component.
onUnmounted(() => onChange.cancel());
</script>

<template>
  <div class="flex">
    <div
      class="flex shrink-0 items-center rounded-l-md bg-white px-3 font-bold text-base text-gray-500 outline-1 -outline-offset-1 outline-gray-300 sm:text-sm/6"
    >
      Saldo
    </div>
    <input
      id="balance"
      v-model="balance"
      aria-label="Saldo"
      class="-ml-px block w-full rounded-r-md bg-white px-3 py-1.5 text-right` text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
      name="balance"
      placeholder="you@example.com"
      type="number"
    />
  </div>
</template>

<style scoped></style>
